import React, { useState } from "react";
import { Box, Button, makeStyles } from "@material-ui/core";
import Page from "../components/Page";
import ListSupportContainer from "../containers/support/ListSupportContainer";
import List from "../views/supports/ListSupports";
import Create from "../views/supports/CreateSupport";
import { Plus } from "react-feather";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    height: "100%",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },

  buttonContainer: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-end",
  },
  button: {
    height: "4rem",
    width: "3rem",
    backgroundColor: "#ccc",
    color: "#fff",
    borderRadius: "50%",
  },
}));

const SupportPage = () => {
  const classes = useStyles();

  const [openCreate, setOpenCreate] = useState(false);

  return (
    <Page className={classes.root} title="Ecat">
      <Box p={2}>
        <Box mb="7%">
          <div className={classes.buttonContainer}>
            <Button
              onClick={() => setOpenCreate(true)}
              className={classes.button}
            >
              <Plus />
            </Button>
          </div>
          <ListSupportContainer>
            {({ content, onSwitchAction }) => (
              <List
                onSwitchAction={onSwitchAction}
                items={content ? content : []}
              />
            )}
          </ListSupportContainer>
        </Box>
      </Box>
      <Create handleClose={() => setOpenCreate(false)} open={openCreate} />
    </Page>
  );
};

export default SupportPage;
